<template lang="pug">
  .custom-textarea
    input.textarea.details-textarea(v-bind="$attrs" @input="$emit('input', $event.target.value)")
    .placeholder {{$attrs.placeholder}}
      span(style='color: #01a5e8', v-if="$attrs.required !== undefined") *
</template>

<script>
  export default {
    prop: ['value'],
  }
</script>

<style lang="scss" scoped>
  @import "../styles/variables";

  .custom-textarea {
    position: relative;
    .details-textarea {
      border-radius: 0;
      border: 1px solid transparent;
      background: transparent;
      padding: 1.5rem 1rem;
      box-shadow: -1px 1px 4px 1px rgba(80, 80, 80, 0.15);

      &::placeholder {
        opacity: 0;
        color: $secondary-colour;
        display: block;
      }

      & + .placeholder {
        position: absolute;
        visibility: hidden;
        top: 0.775rem;
        width: 100%;
        font-weight: normal;
        text-align: left;
        margin-left: 1rem;
        line-height: 1.7;
        font-size: .7rem;
        color: $secondary-colour;
      }

      &:placeholder-shown + .placeholder {
        visibility: visible;
      }

    }


    &.has-error .details-textarea {
      border-color: red;
      color: red;

      & + .placeholder {
        color: red;
      }
    }
  }
</style>
